import { Globe } from "lucide-react"

import { updatePreferredLanguageAction } from "@/app/api/actions"
import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { useServerAction } from "@/hooks/useServerAction"
import { usePathname, useRouter } from "@/i18n/routing"
import type { UserPreferredLanguage } from "@/lib/zenstack/models"
import { useAppUser } from "@/hooks/useGlobalStore"

export function LanguageSelector() {
  const appUser = useAppUser({ required: false })
  const { serverAction: updatePreferredLanguage } = useServerAction(updatePreferredLanguageAction)
  const pathname = usePathname()
  const router = useRouter()

  const onClick = (preferredLanguage: UserPreferredLanguage) => {
    if (appUser.appUser) {
      updatePreferredLanguage({ preferredLanguage })
    }
    router.replace(pathname, { locale: preferredLanguage })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="size-8 rounded-full py-4">
          <Globe className="size-4" />
          <span className="sr-only">Language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="[&>*]:cursor-pointer">
        <DropdownMenuItem onClick={() => onClick("en")}>
          <span>English</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onClick("fr")}>
          <span>Français</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
